<template>
    <layout-update-banner />
    <NuxtLayout>
        <!-- Swap the page instead of hiding NuxtPage, so Nuxt still finishes the navigation and syncs the route -->
        <NuxtPage v-slot="{ Component, route }">
            <layout-maintenance-content
                v-if="portalMaintenance.isActive(route.path)"
                :message="portalMaintenance.message(route.path)"
            />
            <component
                :is="Component"
                v-else
            />
        </NuxtPage>
    </NuxtLayout>
</template>

<script lang="ts" setup>
const portalMaintenance = usePortalMaintenance();
</script>
